import { render, staticRenderFns } from "./ChamadoProgramado.vue?vue&type=template&id=54464332&"
import script from "./ChamadoProgramado.vue?vue&type=script&lang=js&"
export * from "./ChamadoProgramado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports